module.exports = __webpack_public_path__ + "static/media/low-vision.eb385fc0.svg";